import { render, staticRenderFns } from "./EModalTransferirMatricula.vue?vue&type=template&id=7c81fe92&scoped=true"
import script from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"
export * from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"
import style0 from "./EModalTransferirMatricula.vue?vue&type=style&index=0&id=7c81fe92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81fe92",
  null
  
)

export default component.exports